import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { ResponseModel } from '../../models/response.model';
import { appEnv } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  // Roles rarely change and are fetched by several Settings tabs (Roles,
  // Rates, ...) — cache for the life of the app session, invalidated on write.
  private _listCache$: Observable<ResponseModel> | null = null;

  constructor(private http: HttpClient) { }

  getList (): Observable<ResponseModel> {
    if (!this._listCache$) {
      this._listCache$ = this.http.get<ResponseModel>(`${appEnv.api}settings/role`).pipe(shareReplay(1));
    }
    return this._listCache$;
  }

  storeUpdate (id: number = 0, data: Array<any> = []): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(`${appEnv.api}settings/role/store${id ? `?id=${id}` : ''}`, data)
      .pipe(tap(() => this._listCache$ = null));
  }

  delete (id: number = 0): Observable<ResponseModel> {
    return this.http.delete<ResponseModel>(`${appEnv.api}settings/role/${id}`)
      .pipe(tap(() => this._listCache$ = null));
  }

  getByIds (ids: string = ''): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(`${appEnv.api}settings/role/get-by-ids?ids=${ids}`);
  }
}
